module.exports = __webpack_public_path__ + "img/prod_nm.7db952b0.png";